// Optimistic match-record verify toggle, parameterized by resource so tennis
// matches, wrestling matches, and wrestling placements share one hook. Mirrors
// useMarkVerify: optimistic set + revert-on-error, hitting
// POST /{resource}/athlete/{userId}/{id}/verify (resource ∈ 'tennis-matches',
// 'wrestling/matches', 'wrestling/placements'). Staff/partner only.
import { useState } from 'react';
import axios from 'axios';

export default function useMatchRecordVerify({ userId, apiUrl, getConfig, setRows, resource }) {
  const [busyId, setBusyId] = useState(null);

  const toggleVerify = async (r) => {
    const next = !r.verified;
    setBusyId(r.id);
    setRows(list => list.map(x => (x.id === r.id ? { ...x, verified: next } : x)));
    try {
      const res = await axios.post(
        `${apiUrl}/${resource}/athlete/${userId}/${r.id}/verify`, {}, getConfig());
      setRows(list => list.map(x => (x.id === r.id ? { ...x, ...res.data } : x)));
    } catch {
      setRows(list => list.map(x => (x.id === r.id ? { ...x, verified: r.verified } : x)));
    } finally {
      setBusyId(null);
    }
  };

  return { toggleVerify, busyId };
}
